import { defineComponent as _defineComponent } from 'vue'
import { UserNotification } from '@/enitites/user'
import { useRouter } from 'vue-router/composables'
import NotificationEventFeedbackAttendee from './NotificationEventFeedbackAttendee.vue'
import NotificationEventFeedbackOrganizer from './NotificationEventFeedbackOrganizer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationItem',
  props: {
    notification: null,
    readUserNotification: null
  },
  setup(__props: any) {

const props = __props as {
  notification: UserNotification
  readUserNotification: (notification: UserNotification) => void
};



const router = useRouter()

const handleClickLink = () => {
  if (router.currentRoute.path !== props.notification.link) {
    router.push(props.notification.link)
  }
  props.readUserNotification(props.notification)
}

return { __sfc: true,props, router, handleClickLink, NotificationEventFeedbackAttendee, NotificationEventFeedbackOrganizer }
}

})